import React from "react";
import { Text, View } from "@react-pdf/renderer";

import SelectGroup from "../../../../exportacion_react_pdf/SelectGroup";
import QuestionResponse from "../../../../exportacion_react_pdf/QuestionResponse";
import CheckboxGroup from "../../../../exportacion_react_pdf/CheckboxGroup";
import TextAreaLabel from "../../../../exportacion_react_pdf/TextAreaLabel";
import TableGroup from "../../../../exportacion_react_pdf/TableGroup";
import TextAreaLabelGroup from "../../../../exportacion_react_pdf/TextAreaLabelGroup";

// Define el documento
const ExportPecuarioPaso6 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>
                Características del predio Áreas en hectareas
            </Text>

            <QuestionResponse
                label={"Área en producción"}
                value={formData?.pecuario?.area_produccion || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"Área en conservación, bosques, sabanas, humedales"}
                value={formData?.pecuario?.area_conservacion || ""}
            ></QuestionResponse>

            <QuestionResponse
                label={"Área del predio total"}
                value={formData?.pecuario?.area_predio || ""}
            ></QuestionResponse>

            <QuestionResponse
                label={"N° de animales en producción"}
                value={formData?.pecuario?.numero_animales_produccion || ""}
            ></QuestionResponse>

            <SelectGroup
                label='Época lluvia, mes para siembras'
                selectedValue={formData?.pecuario?.epoca_lluvia_meses || ''}>
            </SelectGroup>

            <CheckboxGroup
                label="Manejo de registros"
                selectedValue={formData?.pecuario?.manejo_registros || ""}
                options={['Sí', 'No', 'A veces']}
            ></CheckboxGroup>

            <TableGroup
                questionTitle="Comercialización carne, leche, animales en pie, canal, huevos, genética, silo, cuajada, etc"
                headers={["producto", "cantidad_mes_ano", "venta_unidad", "cliente"]}
                headerDescriptions={["Producto", "Cantidad / mes/año", "Venta/unidad", "Cliente"]}
                data={formData?.pecuario?.lista_comercializacion}
            />
        </View>





        <View style={styles.section}>
            <Text style={styles.title_1}>
                PRIMERA PARTE. IDENTIFICACIÓN DE INFRAESTRUCTURA, EQUIPOS, TÉCNICAS Y PRÁCTICAS DE MANEJO SOSTENIBLE
            </Text>

            <Text style={styles.title_1}>
                1. LÍNEA PRODUCTIVA
            </Text>
            <TableGroup
                questionTitle="Qué tipo de sistema productivo tiene?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_sistema_productivo_tiene}
            />


            <Text style={styles.title_1}>
                2. INFRAESTRUCTURA PRODUCTIVA
            </Text>

            <TableGroup
                questionTitle="¿Qué tipo de infraestructura tiene en el predio?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_infraestructura_predio}
            />

            <Text style={styles.title_1}>
                3. MAQUINARIA Y EQUIPOS
            </Text>

            <TableGroup
                questionTitle="¿Que tipo de maquinaria y equipos tiene para la unidad productiva?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_maquinaria_equipo}
            />

            <Text style={styles.title_1}>
                4. MANEJO DE ALIMENTACIÓN ANIMAL
            </Text>

            <TableGroup
                questionTitle="¿Qué comida proporciona a los animales?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_comina_proporciona_animales}
            />

            <TextAreaLabel
                label={"¿Qué tipo de suplemento utiliza y en qué porcentaje?"}
                value={formData?.pecuario?.tipo_suplemento_porcentaje || ""}
            ></TextAreaLabel>


            <TableGroup
                questionTitle="¿Cómo obtiene la suplementación alimentaria?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_suplemmentacion_alimentaria}
            />


            <TableGroup
                questionTitle="¿Cuenta con pasto de corte, banco mixto o especies establecidas para alimentación alternativa?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_pastos_corte}
            />


            <Text style={styles.title_1}>
                5. MANEJO DE PASTURAS
            </Text>

            <TableGroup
                questionTitle="¿Conoce las prácticas de manejo de pasturas?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_practicas_manejo_pasturas}
            />

            <TextAreaLabel
                label={"¿Qué especies de gramínea y leguminosas están establecidas?"}
                value={formData?.pecuario?.especies_graminea_leguminsas || ""}
            ></TextAreaLabel>


            <Text style={styles.title_1}>
                6. MANEJO SANITARIO Y REPRODUCTIVO
            </Text>

            <TableGroup
                questionTitle="¿Implementa un plan de manejo reproductivo para los animales que cría?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_plan_manejo_reproductivo}
            />

            <TableGroup
                questionTitle="¿Implementa plan de manejo sanitario para los animales que cría?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_plan_manejo_sanitario}
            />

            <TableGroup
                questionTitle="¿Usa medicamentos para el tratamiento  y prevención de enfermedades?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_medicamentos_tratamiento}
            />


            <TableGroup
                questionTitle="¿Lleva registro de aplicación de los medicamentos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_lleva_registro_aplicacion}
            />



            <Text style={styles.title_1}>
                7. MANEJO DE RESIDUOS ORGÁNICOS
            </Text>

            <TableGroup
                questionTitle="¿Las unidades productivas pecuarias generan residuo orgánico?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_unidades_productivas_generan_residuo_organico}
            />

            <TableGroup
                questionTitle="¿Qué tipo de manejo da a los residuos orgánicos? obtenidos?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_tipo_manejo_residuos_organicos}
            />

            <TableGroup
                questionTitle="¿Para qué tipo de práctica utiliza los residuos orgánicos?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_tipo_practica_utiliza_residuos_organicos}
            />


            <Text style={styles.title_1}>
                8. USO ADECUADO DE AGUA PARA CONSUMO ANIMAL
            </Text>

            <TableGroup
                questionTitle="¿Cuál es la principal fuente de agua?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.lista_principal_fuente_agua}
            />

            <TableGroup
                questionTitle="¿Cuenta con sistema de abastecimiento para los animales?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.pecuario?.respuestas_sistema_abastecimiento_para_animales}
            />


        </View>
    </>
);

export default ExportPecuarioPaso6;
